import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { GetCumulativeUserSignUpsDto } from '../../../models/analytics/dto/get-cumulative-user-signups.dto';

export const GET_CUMULATIVE_USER_SIGNUPS_QUERY_KEY = 'getCumulativeUserSignups';

export const useGetCumulativeUserSignups = (organizationId: string) => {
    const apiClient = useApiClient();
    return useQuery({
        queryKey: [GET_CUMULATIVE_USER_SIGNUPS_QUERY_KEY, organizationId],
        queryFn: async () => {
            const response = await apiClient.fetchApi<GetCumulativeUserSignUpsDto, {}>({ method: 'GET', endpoint: `analytics/cumulative-user-signups?organizationId=${organizationId}` });
            return response
        },
        enabled: !!organizationId,
        staleTime: 5 * 60 * 1000,
    });
};
